var React = require('react');

function MenuIcon (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"100","height":"20","fill":"#065C5D","key":0}),React.createElement("rect",{"y":"30","width":"100","height":"20","fill":"#065C5D","key":1}),React.createElement("rect",{"y":"60","width":"100","height":"20","fill":"#065C5D","key":2})]);
}

MenuIcon.defaultProps = {"viewBox":"0 0 100 80","width":"40","height":"40"};

module.exports = MenuIcon;

MenuIcon.default = MenuIcon;
